(function(){
  const $=(s,r=document)=>r.querySelector(s),$$=(s,r=document)=>[...r.querySelectorAll(s)];
  const header=$('#header'),hero=$('.hero');
  if(header&&header.dataset.transparent==='true'&&hero&&'IntersectionObserver' in window){
    new IntersectionObserver(([e])=>header.classList.toggle('solid',!e.isIntersecting),{threshold:.55}).observe(hero);
  } else if(header){header.classList.add('solid')}
  function toggle(el,on){if(!el)return;el.classList.toggle('open',on);el.setAttribute('aria-hidden',on?'false':'true');document.body.classList.toggle('locked',on)}
  const drawer=$('#drawer'),cdr=$('#cartDrawer'),sb=$('#searchbar');
  document.addEventListener('click',e=>{
    if(e.target.closest('[data-open-nav]')){e.preventDefault();toggle(drawer,true)}
    if(e.target.closest('[data-close-nav]'))toggle(drawer,false);
    if(e.target.closest('[data-open-search]')){e.preventDefault();sb.classList.add('open');$('input',sb).focus()}
    if(e.target.closest('[data-close-search]'))sb.classList.remove('open');
    if(e.target.closest('[data-open-cart]')&&cdr){e.preventDefault();refreshCart().then(()=>toggle(cdr,true))}
    if(e.target.closest('[data-close-cart]'))toggle(cdr,false);
    const acc=e.target.closest('.acc__btn');if(acc)acc.parentElement.classList.toggle('is-open');
    const ch=e.target.closest('[data-line-change]');
    if(ch){e.preventDefault();changeLine(ch.dataset.key,+ch.dataset.qty)}
  });
  document.addEventListener('keydown',e=>{if(e.key==='Escape'){toggle(drawer,false);toggle(cdr,false);sb&&sb.classList.remove('open')}});
  function toast(m){let t=$('.toast');if(!t){t=document.createElement('div');t.className='toast';document.body.appendChild(t)}t.textContent=m;t.classList.add('show');setTimeout(()=>t.classList.remove('show'),2200)}
  const root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  async function refreshCart(){
    if(!cdr)return;
    const r=await fetch(root+'?section_id=cart-drawer');const h=await r.text();
    const d=new DOMParser().parseFromString(h,'text/html');
    const nb=d.querySelector('#cartDrawerInner');if(nb)$('#cartDrawerInner').innerHTML=nb.innerHTML;
    const c=await (await fetch(root+'cart.js')).json();$$('[data-cart-count]').forEach(b=>b.textContent=c.item_count);
  }
  async function changeLine(key,qty){
    await fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})});
    if(document.body.dataset.template==='cart'){location.reload();return}
    refreshCart();
  }
  // Product form
  $$('[data-product-form]').forEach(form=>{
    const data=JSON.parse($('[data-variants]',form.closest('.pdp')).textContent);
    const idIn=$('input[name="id"]',form),btn=$('.pdp__cta',form),priceEl=$('#pdpPrice');
    const opts=()=>$$('[data-opt]',form.closest('.pdp')).map(g=>{const c=$('input:checked',g);return c?c.value:null});
    function update(){
      const sel=opts();const v=data.variants.find(v=>v.options.every((o,i)=>o===sel[i]));
      if(!v){btn.disabled=true;btn.textContent=btn.dataset.unavail;return}
      idIn.value=v.id;btn.disabled=!v.available;btn.textContent=v.available?btn.dataset.add:btn.dataset.sold;
      if(priceEl)priceEl.innerHTML=v.price_html;
      const u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState(null,'',u);
    }
    form.closest('.pdp').addEventListener('change',e=>{if(e.target.closest('[data-opt]'))update()});
    form.addEventListener('submit',async e=>{
      if(!cdr)return;e.preventDefault();btn.disabled=true;
      const r=await fetch(root+'cart/add.js',{method:'POST',body:new FormData(form)});
      btn.disabled=false;
      if(!r.ok){const j=await r.json();toast(j.description||'Could not add');return}
      await refreshCart();toggle(cdr,true);
    });
  });
  // Thumbs
  $$('.pdp__thumb').forEach(b=>b.addEventListener('click',()=>{
    $$('.pdp__thumb').forEach(x=>x.classList.toggle('is-on',x===b));
    const s=$('.pdp__shot[data-i="'+b.dataset.i+'"]');s&&s.scrollIntoView({behavior:'smooth',block:'nearest'});
  }));
  // Sort
  const sort=$('#sortSel');if(sort)sort.addEventListener('change',()=>{const u=new URL(location.href);u.searchParams.set('sort_by',sort.value);location.href=u});
})();

/* Scroll reveal */
(function(){
  if(!('IntersectionObserver' in window)||matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  var st=document.createElement('style');
  st.textContent='.rv{opacity:0;transform:translateY(28px);transition:opacity 1s cubic-bezier(.2,.7,.2,1),transform 1.1s cubic-bezier(.2,.7,.2,1);transition-delay:var(--rvd,0s);will-change:opacity,transform}.rv.rv-in{opacity:1;transform:none}.rv-img{overflow:hidden}.rv-img img{transform:scale(1.08);transition:transform 1.6s cubic-bezier(.2,.7,.2,1)}.rv-img.rv-in img{transform:scale(1)}.duo__tile.rv-img.rv-in:hover img{transform:scale(1.04)}';
  document.head.appendChild(st);
  var groups=[['.hero__eye,.hero__title,.hero__cats,.hero__cta',0.12],['.duo__tile',0.15],['.duo__cap > *',0.1],['.sec__head > *',0.08],['.pg .pc',0.08],['.iwt__media',0],['.iwt__copy > *',0.1],['.statement > *, .statement__eye, .statement__h, .statement__p',0.1],['.newsletter > *',0.1],['.footer > *',0.06]];
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('rv-in');io.unobserve(e.target);}});},{rootMargin:'0px 0px -8% 0px',threshold:0.12});
  function scan(root){
    groups.forEach(function(g){
      var seen=new Map();
      root.querySelectorAll(g[0]).forEach(function(el){
        if(el.classList.contains('rv'))return;
        var p=el.parentElement,i=seen.get(p)||0;seen.set(p,i+1);
        el.classList.add('rv');
        if(el.matches('.duo__tile,.iwt__media'))el.classList.add('rv-img');
        el.style.setProperty('--rvd',Math.min(i*g[1],0.6)+'s');
        io.observe(el);
      });
    });
  }
  function start(){scan(document);}
  if(document.readyState!=='loading')start();else document.addEventListener('DOMContentLoaded',start);
  document.addEventListener('shopify:section:load',function(e){scan(e.target);e.target.querySelectorAll('.rv').forEach(function(el){el.classList.add('rv-in');});});
})();